import styles from './ac-table.module.scss'

interface IAcTableProps {
  children: React.ReactNode
}

export const AcTable = ({ children }: IAcTableProps) => {
  return <table className={styles['ac-table']}>{children}</table>
}
